import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import './i18n';
import LocationsList from './components/locations/LocationsList';
import LocationForm from './components/locations/LocationForm';
import LoginForm from './components/auth/LoginForm';
import ForgotPasswordForm from './components/auth/ForgotPasswordForm';
import ResetPasswordForm from './components/auth/ResetPasswordForm';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ClientsPage from './pages/ClientsPage';
import TwoFactorSetup from './components/auth/TwoFactorSetup';
import OpeningHourCategoriesPage from './components/openingHourCategories/OpeningHourCategoriesPage';
import LanguagesPage from './components/languages/LanguagesPage';
import LanguageTranslationsPage from './components/languages/LanguageTranslationsPage';
import NewsList from './components/news/NewsList';
import NewsForm from './components/news/NewsForm';
import ImprintPage from './pages/ImprintPage';
import ChangePasswordPage from './pages/ChangePasswordPage';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <CssBaseline />
          <Routes>
            <Route path="/login" element={<LoginForm />} />
            <Route path="/forgot-password" element={<ForgotPasswordForm />} />
            <Route path="/reset-password" element={<ResetPasswordForm />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<HomePage />} />
              <Route path="locations" element={<LocationsList />} />
              <Route path="locations/new" element={<LocationForm />} />
              <Route path="locations/:id/edit" element={<LocationForm />} />
              <Route path="opening-hour-categories" element={<OpeningHourCategoriesPage />} />
              <Route path="languages" element={<LanguagesPage />} />
              <Route path="languages/:id/translations" element={<LanguageTranslationsPage />} />
              <Route path="news" element={<NewsList />} />
              <Route path="news/new" element={<NewsForm />} />
              <Route path="news/:id/edit" element={<NewsForm />} />
              <Route path="imprint" element={<ImprintPage />} />
              <Route path="clients" element={<ClientsPage />} />
              <Route path="settings" element={<TwoFactorSetup />} />
              <Route path="change-password" element={<ChangePasswordPage />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App; 